<template>
  <div
    v-click-outside="closeDropdown"
    class="lang-switcher"
    :class="{ loaded: languages.length }"
  >
    <button class="lang-switcher__current" @click="toggleDropdown">
      <span class="arrow" :class="{ open: isOpen }"><WordIcon /></span>
      {{ currentLabel }}
    </button>

    <div class="lang-switcher__list" :class="{ open: isOpen }">
      <div class="lang-switcher__top">
        <div class="lang-switcher__left">
          <WordIcon />
          <span>{{ currentLangTitle }}</span>
        </div>
        <span class="close-icon" @click="closeDropdown">
            <Close />
        </span>
      </div>

      <div
        v-for="lang in languages.filter(l => l.visible)"
        :key="lang.code"
        class="lang-switcher__item"
        :class="{ selected: currentLang === lang.code }"
        @click="changeLang(lang.code)"
      >
        <div class="circle" :class="{ active: currentLang === lang.code }"></div>
        {{ lang.label }}
      </div>
    </div>
  </div>
</template>

<script>
  import WordIcon from '@/assets/img/icons/lang.svg?inline'
  import Close from '@/assets/img/icons/close-new.svg?inline'

  export default {
    name: 'LangSwitcher',
    components: {
      WordIcon,
      Close
    },
    directives: {
      clickOutside: {
        bind (el, binding) {
          el.clickOutsideEvent = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
              binding.value(event)
            }
          }
          document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind (el) {
          document.body.removeEventListener('click', el.clickOutsideEvent)
        }
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    computed: {
      languages () {
        return this.$store.state.languages || []
      },
      currentLang () {
        return this.$store.state.currentLang
      },
      currentLangTitle () {
        const general = this.$store.state.general
        return (general && general.languageLabel) || ''
      },
      currentLabel () {
        const lang = this.languages.find(l => l.code === this.currentLang)
        return lang ? lang.label : 'Lang'
      }
    },
    methods: {
      toggleDropdown () {
        this.isOpen = !this.isOpen
      },
      closeDropdown () {
        this.isOpen = false
      },
      changeLang (code) {
        if (this.currentLang === code) return
        this.$store.commit('setCurrentLang', code)
        window.axios.defaults.headers.common['Accept-Language'] = code
        this.isOpen = false
      }
    }
  }
</script>

<style scoped lang="scss">

.lang-switcher {
  position: relative;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0;
  vertical-align: middle;
  padding: 0;
  line-height: 1.1;
  opacity: 0;
  transition: 0.4s;

  .close-icon {
    cursor: pointer;
    width: 20px;
    height: 20px;

    svg {
      display: block;
    }
  }

  &.loaded {
    opacity: 1;
  }

  svg {
    display: block;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 24px;

    svg {
      position: relative;
      top: 1px;
    }
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 8px;

    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
      vertical-align: middle;
      color: $c-black2;
    }

    svg {
      position: relative;
      top: 1px;
    }
  }

  &__current {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0;
    transition: 0.2s;
    gap: 8px;

    svg {
      display: block;
      position: relative;
      top: 1px;
    }
  }

  .lang-switcher__list {
    padding: 24px 16px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-10px);
    width: 180px;
    background: #fff;
    border: 1px solid #ddd;
    margin-top: 0.25em;
    list-style: none;
    z-index: 9999999;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;

    &.open {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transform: translateX(-50%) translateY(0);

      @media (max-width: 1024px) {
        transform: translate(0, 0);
      }
    }

    @media (max-width: 1024px) {
      left: unset;
      transform: translate(0, -10px);
      right: 0;
    }
  }

  .lang-switcher__item {
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &:hover {
      .circle {
        background: #a8aaac;
      }
    }
  }

  .circle {
    position: relative;
    width: 20px;
    height: 20px;
    border: 1px solid #a8aaac;
    border-radius: 50%;
    transition: 0.35s;

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
      background: $c-black;
      border-radius: 50%;
      opacity: 0;
      transition: 0.35s;
    }

    &.active {
      background: #fff !important;

      &::after {
        opacity: 1;
      }
    }
  }
}
</style>
